import React from 'react';

import { BorderBox, Heading, Text } from '@primer/components'

import { PieChart } from 'react-minimal-pie-chart';



export default function(props) {
  const data = []
  if (props.security) {
    data.push({ title: 'Security', value: props.security, color: '#dcffe4' })
  }
  if (props.performance) {
    data.push({ title: 'Performance', value: props.performance, color: '#f1f8ff' })
  }
  if (props.maintainability) {
    data.push({ title: 'Maintainability', value: props.maintainability, color: '#ffeef0' })
  }
  if (props.bugs) {
    data.push({ title: 'Bugs', value: props.bugs, color: '#dcf7ff' })
  }
  if (props.testing) {
    data.push({ title: 'Test quality', value: props.testing, color: '#e0dcff' })

  }

  return (
    <BorderBox className="pl-4 pr-4 pb-4 pt-2">
      <Heading fontSize={4} className="mb-4">Categories</Heading>
      <PieChart
        data={data}
        label={props => props.dataEntry.title}
        labelStyle={{fontSize: '7px'}}
      />
      <ul className="bullet-list-blue ml-4 mt-4 f3">
        <Text as="li">Security: {props.security}</Text>
        <Text as="li">Performance: {props.performance}</Text>
        <Text as="li">Maintainability: {props.maintainability}</Text>
        <Text as="li">Test quality: {props.testing}</Text>
        <Text as="li">Bugs: {props.bugs}</Text>
      </ul>
    </BorderBox>
  )
}
